import script from "./form-release.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-release.vue?vue&type=script&setup=true&lang=ts"

import "./form-release.vue?vue&type=style&index=0&id=49e8ee77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e8ee77"]])

export default __exports__